export default __webpack_public_path__ + "static/media/bg-lesson.5ea5c013.png";